import { Component, OnInit, ViewChild, Input, OnDestroy,AfterViewInit, ElementRef } from '@angular/core';
import { Subject } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { map } from "rxjs/operators";

import { Color, Label } from 'ng2-charts';


import {
  ApexAxisChartSeries,
  ApexChart,
  ChartComponent,
  ApexDataLabels,
  ApexXAxis,
  ApexPlotOptions,
} from "ng-apexcharts";

import { NgxPermissionsService, NgxRolesService } from 'ngx-permissions';

//import constants
import { AppSettings } from '../../../../../constants/app-settings';
import { AppFrontRoutes } from '../../../../../constants/app-front-routes';

//import services
import { ServicingService } from '../../../../../services/servicing.service';
import { EmployeeService } from '../../../../../services/employee.service';
import { ConfirmationDialogService } from '../../../../general/modals/confirmation/confirmation.service';
import { GeneralService } from '../../../../../services/general.service';

//import multiselectdropdown
import { IDropdownSettings } from 'ng-multiselect-dropdown';

//import components
import { EmployeeCreateComponent } from '../../employee-create/employee-create.component';

// import * as html2canvas from 'html2canvas';
import * as htmlToImage from 'html-to-image';
import { toPng, toJpeg, toBlob, toPixelData, toSvg } from 'html-to-image';
import { trim } from 'jquery';

import { EmployeeViewemployeeComponent } from '../../../human_resources/employee-list/employee-viewemployee/employee-viewemployee.component';

import { CreateDeliveryReportComponent } from '../../../human_resources/employee-list/employee-createdelivery/employee-createdelivery.component';

import { CreateAddProtectiveComponent } from '../../../human_resources/employee-list/employee-createaddprotective/employee-createaddprotective.component';


import { CreateAddThirdProtectiveComponent } from '../../../human_resources/employee-list/employee-createaddthirdprotective/employee-createaddthirdprotective.component';

import { SendMailDpiComponent } from '../../../human_resources/employee-list/employee_dpiemail/employee-dpiemail.component';
import { e } from '@angular/core/src/render3';
import ApexCharts from 'apexcharts/dist/apexcharts.common.js'
import { CommonUtility } from "../../../../../utility/commonUtility"
import { fromEvent } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  xaxis: ApexXAxis;
};

declare var $: any;

@Component({
  selector: 'app-employee-view',
  templateUrl: './employee-view.component.html',
  styleUrls: ['./employee-view.component.css']
})



export class EmployeeViewComponent implements OnDestroy, OnInit, AfterViewInit {
  @ViewChild('trainingSearch') trainingSearch;
  @ViewChild('medicalSearch') medicalSearch;
  @ViewChild('notificationSearch') notificationSearch;
  
  getPhotoBase64;
  dropdownList = [];
  dropdownList1 = [];
  dropdownList2 = [];
  dropdownList3 = [];
  selectedItems = [];
  dropdownSettings = {};
  dropdownSettings1 = {};
  dropdownSettings2 = {};
  dropdownSettings3 = {};
  //dropdownSettings:IDropdownSettings;

  //common data
  data: any;

  readonly AppSettings = AppSettings;
  readonly AppFrontRoutes = AppFrontRoutes;

  datatableOptions1: any;
  datatableOptions2: any;
  datatableOptions3: any;
  datatableOptions4: any;
  datatableOptions5: any;
  datatableOptions6: any;
  datatableTrigger1: Subject<any> = new Subject();
  datatableColsDefs1: any;
  datatableColsDefs2: any;
  datatableColsDefs4: any;
  datatableColsDefs5: any;
  datatableColsDefs6: any;
  datatableCols1: any;
  datatableCols2: any;
  datatableCols3: any;
  datatableCols4: any;
  datatableCols5: any;
  datatableCols6: any;
  datatableAddCols1: any;

  @Input() filter1: string;
  @Input() filter2: string;
  @Input() filter3: string;
  @Input() filter4: string;
  @ViewChild(DataTableDirective) datatableElement: DataTableDirective;
  @ViewChild('generalChart') generalChart:ElementRef;
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();

  addServicingModal: BsModalRef;
  viewServicingModal: BsModalRef;
  viewEmployeeModal: BsModalRef;
  addDeliveryreportModel: BsModalRef;
  sendMailModel: BsModalRef;
  addProtectiveModel: BsModalRef;
  addProtectiveModel2: BsModalRef;
  addExtraModel: BsModalRef;
  addMaintenanceModel: BsModalRef;
  deleteOption: any;
  extraordinayModal: BsModalRef;
  ordinayModal: BsModalRef;
  ordinary_data: BsModalRef;
  isApiLoaded:boolean = false
  lang: any;
  odlang: any;
  exodlang: any;
  generalData: any;
  mLang: any;
  maintenanceData: any;
  records: any;
  single_data: any;
  plans: any;
  imgQR: any;
  exordinary_data: any;
  documents_data: any;
  planvals: any;
  cnt: any;
  doclang: any;
  emp: any;
  training: any;
  training_temp: any;
  medical_temp: any;
  leftside: any;
  rightside: any;
  allrec_round: any;
  chart_left: any;
  chart_right: any;
  chart_center: any;
  chartdata: any;
  first1: any;
  tab2seconddpi: any;
  device: any;
  medicalData: any;
  notify_temp:any;
  notifi: any;
  showContent: any;
  pageView: string = 'list';
  timezone = localStorage.getItem('timezone');

  id: number;
  curriculum: any;
  contract: any;
  cexpiry: any;
  coexpiry: any;
  identity: any;
  drivers: any;
  idexpiry: any;
  iddrivers: any;
  cid: any;
  conid: any;
  identityid: any;
  did: any;
  coption: any;
  conoption: any;
  idoption: any;
  doption: any;

  generalsForm: FormGroup;
  generalsFormSubmitted: Boolean = false;
  generalsFormMsg: any;
  rolepermission: any;

  createForm: FormGroup;
  createFormSubmitted: Boolean = false;
  createFormErrorMsg: any;

  createForm2: FormGroup;
  createFormSubmitted2: Boolean = false;
  createFormErrorMsg2: any;

  createForm3: FormGroup;
  createFormSubmitted3: Boolean = false;
  createFormErrorMsg3: any;

  createForm4: FormGroup;
  createFormSubmitted4: Boolean = false;
  createFormErrorMsg4: any;

  barChartMaxValues:any;
  barChartLabels: any;
  barChartValues: any;
  barChartType: any;
  chartColors: any;
  barChartLegend: any;
  barChartData: any;
  backgroundColor: any;

  @ViewChild("chart") chart: ChartComponent;
  public chartOptions: Partial<ChartOptions>;

  // public chartColors: any[] = [
  //   { 
  //     backgroundColor:["#008000", "#ff0000", "#ff0000"] 
  //   }];


  constructor(
    private formBuilder: FormBuilder,

    private servicingService: ServicingService,
    private modalService: BsModalService,
    private employeeService: EmployeeService,

    private confirmationDialogService: ConfirmationDialogService,
    private route: ActivatedRoute,
    private router: Router,
    private generalService: GeneralService,
    private ngxRolesService: NgxRolesService,
    private utility: CommonUtility
  ) { }


  public barChartOptions = {
    scaleShowVerticalLines: false,
    responsive: true
  };

  ngOnInit() {
    //fetch data

    this.data = this.route.snapshot.data['sdata'];
    // console.log(this.data);  

    var role = this.ngxRolesService.getRole('servicing');

    this.rolepermission = '';
    if (role) {
      this.rolepermission = role.validationFunction[0];
    }

  

    // this.training = [];
    this.first1 = [];
    this.tab2seconddpi = [];
    this.device = [];

    this.generalsFormInit();
    this.getData();
    this.fileDesign();
    this.tab2Actions();

    // this.tab3firstActions();
    // this.tab3secondActions();
    // this.tab3thirdActions();
    this.tab4Actions();
    this.tab5Actions();

  }

  loadChart(){
    const curObj = this
    let colorFuncArr = []

    for(var index of this.barChartMaxValues){
      colorFuncArr.push(
          (function(val) { return function(){  
            return '#ff0000'
            // if (value > curObj.barChartMaxValues[curObj.barChartValues.indexOf(value)]) {
            //   return '#14b714'
            // } else {
            //   return '#ff0000'
            // }
      }})(index) 
      )
    }

    var options = {
      series: [{
      data: JSON.parse(this.barChartValues)
      }],
      colors:[
        function({ value, seriesIndex, dataPointIndex, w }) {
          let i = w.config.series[0].data[dataPointIndex]['x']
          if (value > curObj.barChartMaxValues[dataPointIndex]) {
            return '#14b714'
        } else {
            return '#ff0000'
        }
        }        
      ],
      
      chart: {
      type: 'bar',
      height: 350
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        horizontal: true,
      }
    },
    dataLabels: {
      enabled: false
    },
    xaxis: {
      categories: this.barChartLabels,
    }
    };
    console.log(options)
    console.log(this.generalChart)
    setTimeout(function(){
      console.log("========= Chart ========")
      // console.log(document.getElementById('#chart'))
      console.log(this.generalChart)
      var chart = new ApexCharts(this.generalChart, options)
      chart.render()        
    },2000)
  }

  ngAfterViewInit(){

    const that = this
    setTimeout(function(){
      console.log(this.trainingSearch)
      fromEvent(this.trainingSearch, 'keydown')
      .pipe(
        debounceTime(550),
        map(x => x['target']['value'])
      )
      .subscribe(value => {
        // this.updateFilter(value);
        console.log(that.utility)
        console.log(that.datatableCols2)
        console.log(that.records)
        that.training = that.utility.updateFilter(value,that.datatableCols1,that.training,that.training_temp)
      });  
      
      fromEvent(this.medicalSearch, 'keydown')
      .pipe(
        debounceTime(550),
        map(x => x['target']['value'])
      )
      .subscribe(value => {
        // this.updateFilter(value);
        console.log(that.utility)
        console.log(that.datatableCols2)
        console.log(that.records)
        that.medicalData = that.utility.updateFilter(value,that.datatableCols5,that.medicalData,that.medical_temp)
      });     
      
      fromEvent(this.notificationSearch, 'keydown')
      .pipe(
        debounceTime(550),
        map(x => x['target']['value'])
      )
      .subscribe(value => {
        // this.updateFilter(value);
        console.log(that.utility)
        console.log(that.datatableCols2)
        console.log(that.records)
        that.notifi = that.utility.updateFilter(value,that.datatableCols6,that.notifi,that.notify_temp)
      });           
      
    },3000)    

  }


  onItemSelect(item: any) {
    console.log(item.item_id);
  }
  onSelectAll(items: any) {
    console.log(items);
  }


  ngOnDestroy(): void {
    $.fn['dataTable'].ext.search.pop();
  }

  pdfDownload() {
    var node = document.getElementById('QR_div');

    htmlToImage.toJpeg(node)
      .then(function (dataUrl) {
        // console.log(dataUrl); return false;
        var img = new Image();
        img.src = dataUrl;
        // document.body.appendChild(img);
        document.getElementById("imgQRD").click();
      })
      .catch(function (error) {
        console.error('oops, something went wrong!', error);
      });

  }

  datatableConfig1(): void {

    this.datatableColumns1();

    this.datatableOptions1 = {
      paging: false,
      bAutoWidth: false,
      bSortClasses: false,
      bPaginate:false,      
      columnDefs: this.datatableColsDefs1,
      headerCallback: function (thead, data, start, end, display) {

        $('th:first-child input', thead).unbind('click');
        $('th:first-child input', thead).bind('click', () => {

          var table1 = new $.fn.dataTable.Api('#table1');

          var count = table1.rows({ selected: true }).count();
          let selected = true;

          if (count > 0) {
            table1.rows().deselect();
            selected = false;
          }
          else
            table1.rows().select();

          $('th:first-child input', thead).prop("checked", selected);

        });
      },
      initComplete: () => {

        var self = this;
        var table1 = new $.fn.dataTable.Api('#table1');

        // console.log(table2);

        table1
          .on('select deselect', function (e, dt, type, indexes) {

            var table1 = new $.fn.dataTable.Api('#table1');
            var selected = table1.rows({ selected: true }).indexes().toArray();

            if (selected.length === 0)
              self.deleteOption = false;
            else
              self.deleteOption = true;
          });

        var buttons2 = new $.fn.dataTable.Buttons(table1, {

          dom: {
            button: {
              className: ''
            }
          },
          buttons: [
            {

              extend: 'csv',
              text: 'Export CSV',
              className: 'btn btn-info',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table1');
                  var selected = dt.rows({ selected: true }).indexes().toArray();
                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "KaizenCloud"
            },
            {
              extend: 'pdfHtml5',
              text: 'Export PDF',
              className: 'btn btn-info',
              orientation: 'landscape',
              pageSize: 'A3',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table1');
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;


                  return false;
                }
              },
              title: "KaizenCloud"
            },
            {
              extend: 'excel',
              text: 'Export Excel',
              className: 'btn btn-info',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table1');
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "KaizenCloud"
            },
            {
              extend: 'print',
              text: 'Print',
              className: 'btn btn-info',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table1');
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "KaizenCloud"
            },
          ], select: true
        }).container().appendTo($('#datatableExportBtn1'));

      }
    }

  }

  datatableConfig2(): void {

    this.datatableColumns2();

    this.datatableOptions2 = {
      paging: false,
      bAutoWidth: false,
      bSortClasses: false,
      headerCallback: function (thead, data, start, end, display) {

        $('th:first-child input', thead).unbind('click');
        $('th:first-child input', thead).bind('click', () => {

          var table2 = new $.fn.dataTable.Api('#table2');

          var count = table2.rows({ selected: true }).count();
          let selected = true;

          if (count > 0) {
            table2.rows().deselect();
            selected = false;
          }
          else
            table2.rows().select();

          $('th:first-child input', thead).prop("checked", selected);

        });
      },
      initComplete: () => {

        var self = this;
        var table2 = new $.fn.dataTable.Api('#table2');

        // console.log(table2);

        table2
          .on('select deselect', function (e, dt, type, indexes) {

            var table2 = new $.fn.dataTable.Api('#table2');
            var selected = table2.rows({ selected: true }).indexes().toArray();

            if (selected.length === 0)
              self.deleteOption = false;
            else
              self.deleteOption = true;
          });

        var buttons2 = new $.fn.dataTable.Buttons(table2, {

          dom: {
            button: {
              className: ''
            }
          },
          buttons: [
            {

              extend: 'csv',
              text: 'Export CSV',
              className: 'btn btn-info',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table2');
                  var selected = dt.rows({ selected: true }).indexes().toArray();
                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "KaizenCloud"
            },
            {
              extend: 'pdfHtml5',
              text: 'Export PDF',
              className: 'btn btn-info',
              orientation: 'landscape',
              pageSize: 'A3',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table2');
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;


                  return false;
                }
              },
              title: "KaizenCloud"
            },
            {
              extend: 'excel',
              text: 'Export Excel',
              className: 'btn btn-info',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table2');
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "KaizenCloud"
            },
            {
              extend: 'print',
              text: 'Print',
              className: 'btn btn-info',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table2');
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "KaizenCloud"
            },
          ], select: true
        }).container().appendTo($('#datatableExportBtn2'));

      }
    }

  }

  datatableConfig3(): void {

    this.datatableColumns3();

    this.datatableOptions3 = {
      paging: false,
      bAutoWidth: false,
      bSortClasses: false,
      headerCallback: function (thead, data, start, end, display) {

        $('th:first-child input', thead).unbind('click');
        $('th:first-child input', thead).bind('click', () => {

          var table3 = new $.fn.dataTable.Api('#table3');

          var count = table3.rows({ selected: true }).count();
          let selected = true;

          if (count > 0) {
            table3.rows().deselect();
            selected = false;
          }
          else
            table3.rows().select();

          $('th:first-child input', thead).prop("checked", selected);

        });
      },
      initComplete: () => {

        var self = this;
        var table3 = new $.fn.dataTable.Api('#table3');

        table3
          .on('select deselect', function (e, dt, type, indexes) {

            var table3 = new $.fn.dataTable.Api('#table3');
            var selected = table3.rows({ selected: true }).indexes().toArray();

            if (selected.length === 0)
              self.deleteOption = false;
            else
              self.deleteOption = true;
          });

        var buttons2 = new $.fn.dataTable.Buttons(table3, {

          dom: {
            button: {
              className: ''
            }
          },
          buttons: [
            {

              extend: 'csv',
              text: 'Export CSV',
              className: 'btn btn-info',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table3');
                  var selected = dt.rows({ selected: true }).indexes().toArray();
                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "KaizenCloud"
            },
            {
              extend: 'pdfHtml5',
              text: 'Export PDF',
              className: 'btn btn-info',
              orientation: 'landscape',
              pageSize: 'A3',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table3');
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;


                  return false;
                }
              },
              title: "KaizenCloud"
            },
            {
              extend: 'excel',
              text: 'Export Excel',
              className: 'btn btn-info',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table3');
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "KaizenCloud"
            },
            {
              extend: 'print',
              text: 'Print',
              className: 'btn btn-info',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table3');
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "KaizenCloud"
            },
          ], select: true
        }).container().appendTo($('#datatableExportBtn3'));

      }
    }

  }

  datatableConfig4(): void {

    this.datatableColumns4();

    this.datatableOptions4 = {
      paging: false,
      bAutoWidth: false,
      bSortClasses: false,
      headerCallback: function (thead, data, start, end, display) {

        $('th:first-child input', thead).unbind('click');
        $('th:first-child input', thead).bind('click', () => {

          var table4 = new $.fn.dataTable.Api('#table4');

          var count = table4.rows({ selected: true }).count();
          let selected = true;

          if (count > 0) {
            table4.rows().deselect();
            selected = false;
          }
          else
            table4.rows().select();

          $('th:first-child input', thead).prop("checked", selected);

        });
      },
      initComplete: () => {

        var self = this;
        var table4 = new $.fn.dataTable.Api('#table4');

        // console.log(table4);

        table4
          .on('select deselect', function (e, dt, type, indexes) {

            var table4 = new $.fn.dataTable.Api('#table4');
            var selected = table4.rows({ selected: true }).indexes().toArray();

            if (selected.length === 0)
              self.deleteOption = false;
            else
              self.deleteOption = true;
          });

        var buttons2 = new $.fn.dataTable.Buttons(table4, {

          dom: {
            button: {
              className: ''
            }
          },
          buttons: [
            {

              extend: 'csv',
              text: 'Export CSV',
              className: 'btn btn-info',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table4');
                  var selected = dt.rows({ selected: true }).indexes().toArray();
                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "KaizenCloud"
            },
            {
              extend: 'pdfHtml5',
              text: 'Export PDF',
              className: 'btn btn-info',
              orientation: 'landscape',
              pageSize: 'A3',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table4');
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;


                  return false;
                }
              },
              title: "KaizenCloud"
            },
            {
              extend: 'excel',
              text: 'Export Excel',
              className: 'btn btn-info',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table4');
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "KaizenCloud"
            },
            {
              extend: 'print',
              text: 'Print',
              className: 'btn btn-info',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table4');
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "KaizenCloud"
            },
          ], select: true
        }).container().appendTo($('#datatableExportBtn4'));

      }
    }

  }

  datatableConfig5(): void {

    this.datatableColumns5();

    this.datatableOptions5 = {
      paging: false,
      bAutoWidth: false,
      bSortClasses: false,
      columnDefs: this.datatableColsDefs5,
      select: {
        style: 'multi',
        selector: 'td:first-child'
      },
      headerCallback: function (thead, data, start, end, display) {

        $('th:first-child input', thead).unbind('click');
        $('th:first-child input', thead).bind('click', () => {

          var table5 = new $.fn.dataTable.Api('#table5');

          var count = table5.rows({ selected: true }).count();
          let selected = true;

          if (count > 0) {
            table5.rows().deselect();
            selected = false;
          }
          else
            table5.rows().select();

          $('th:first-child input', thead).prop("checked", selected);

        });
      },
      initComplete: () => {

        var self = this;
        var table5 = new $.fn.dataTable.Api('#table5');

        table5
          .on('select deselect', function (e, dt, type, indexes) {

            var table5 = new $.fn.dataTable.Api('#table5');
            var selected = table5.rows({ selected: true }).indexes().toArray();

            if (selected.length === 0)
              self.deleteOption = false;
            else
              self.deleteOption = true;
          });

        var buttons2 = new $.fn.dataTable.Buttons(table5, {

          dom: {
            button: {
              className: ''
            }
          },
          buttons: [
            {

              extend: 'csv',
              text: 'Export CSV',
              className: 'btn btn-info',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table5');
                  var selected = dt.rows({ selected: true }).indexes().toArray();
                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "KaizenCloud"
            },
            {
              extend: 'pdfHtml5',
              text: 'Export PDF',
              className: 'btn btn-info',
              orientation: 'landscape',
              pageSize: 'A3',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table5');
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;


                  return false;
                }
              },
              title: "KaizenCloud"
            },
            {
              extend: 'excel',
              text: 'Export Excel',
              className: 'btn btn-info',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table5');
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "KaizenCloud"
            },
            {
              extend: 'print',
              text: 'Print',
              className: 'btn btn-info',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table5');
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "KaizenCloud"
            },
          ], select: true
        }).container().appendTo($('#datatableExportBtn5'));

      }
    }

  }

  datatableConfig6(): void {
    this.datatableColumns6();

    this.datatableOptions6 = {
      paging: false,
      bAutoWidth: false,
      bSortClasses: false,
      bPaginate:false,
      columnDefs: this.datatableColsDefs6,
      select: {
        style: 'multi',
        selector: 'td:first-child'
      },
      headerCallback: function (thead, data, start, end, display) {

        $('th:first-child input', thead).unbind('click');
        $('th:first-child input', thead).bind('click', () => {

          var table6 = new $.fn.dataTable.Api('#table6');

          var count = table6.rows({ selected: true }).count();
          let selected = true;

          if (count > 0) {
            table6.rows().deselect();
            selected = false;
          }
          else
            table6.rows().select();

          $('th:first-child input', thead).prop("checked", selected);

        });
      },
      drawCallback: function(settings) {
        console.log(settings)
        var pagination = $(this).closest('.dataTables_wrapper').find('.dataTables_paginate');
        console.log(pagination)
        pagination.toggle(this.api().page.info().pages > 1);
      },      
      initComplete: () => {

        var self = this;
        var table6 = new $.fn.dataTable.Api('#table6');

        table6
          .on('select deselect', function (e, dt, type, indexes) {

            var table4 = new $.fn.dataTable.Api('#table6');
            var selected = table4.rows({ selected: true }).indexes().toArray();

            if (selected.length === 0)
              self.deleteOption = false;
            else
              self.deleteOption = true;
          });

        var buttons2 = new $.fn.dataTable.Buttons(table6, {

          dom: {
            button: {
              className: ''
            }
          },
          buttons: [
            {

              extend: 'csv',
              text: 'Export CSV',
              className: 'btn btn-info',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table6');
                  var selected = dt.rows({ selected: true }).indexes().toArray();
                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "KaizenCloud"
            },
            {
              extend: 'pdfHtml5',
              text: 'Export PDF',
              className: 'btn btn-info',
              orientation: 'landscape',
              pageSize: 'A3',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table6');
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;


                  return false;
                }
              },
              title: "KaizenCloud"
            },
            {
              extend: 'excel',
              text: 'Export Excel',
              className: 'btn btn-info',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table6');
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "KaizenCloud"
            },
            {
              extend: 'print',
              text: 'Print',
              className: 'btn btn-info',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table6');
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "KaizenCloud"
            },
          ], select: true
        }).container().appendTo($('#datatableExportBtn6'));

      }
    }

  }

  close() {
    $('#odatatableExport3').modal('hide');
    // $('#datatableExportBtn3').detach();
    $('#odatatableExport3').clear();
  }

  onchk(i, j) {
    // console.log($('#'+i).hasClass('selected'));

    $('.dmulval').val('');
    if ($('#' + i).hasClass('selected') == false) {
      $('.odplus_del' + j).css('display', 'inline-block');
      $('.dmulval').val(i);
    }
    else {
      $('.odplus_del' + j).css('display', 'none');
      $('.dmulval').val('');
    }

  }

  datatableColumns1(): void {
    this.datatableColsDefs1 = [
      {
        targets: 0,
        visible: false,
        orderable: false,
      },
      {
        targets: 1,
        orderable: false,
        className: 'select-checkbox'
      },
    ];

    this.datatableCols1 = [
      { id: 2, value: 'No.', isSelected: false },
      { id: 3, value: 'Course Code', isSelected: false },
      { id: 4, value: 'Course attended', isSelected: false },
      { id: 5, value: 'Type', isSelected: false },
      { id: 6, value: 'Duration ( hours )', isSelected: false },
      { id: 7, value: 'Start Date', isSelected: false },
      { id: 8, value: 'End Date', isSelected: false },
      { id: 9, value: 'Teacher', isSelected: false },
      { id: 10, value: 'Outcome', isSelected: false },
      { id: 11, value: 'Certificate', isSelected: false }
    ];

    // this.datatableAddCols1 = [
    // { id: 2, value: 'Attachments', isSelected: false },
    // ];

  }


  datatableColumns2(): void {

    this.datatableCols2 = [
      { id: 0, value: 'Description', isSelected: false },
      { id: 1, value: 'Date', isSelected: false },
      { id: 2, value: 'Notes', isSelected: false },
      { id: 3, value: 'Attachments', isSelected: false },
    ];

  }

  datatableColumns3(): void {

    this.datatableCols3 = [
      { id: 0, value: 'Device Name', isSelected: false },
      { id: 1, value: 'Date Assignment', isSelected: false },
      { id: 2, value: 'Type', isSelected: false },
      { id: 3, value: 'Part of the body protected', isSelected: false },
      { id: 4, value: 'Attachments', isSelected: false },
    ];
  }


  datatableColumns4(): void {

    this.datatableCols4 = [
      { id: 0, value: 'Device Name', isSelected: false },
      { id: 1, value: 'Brand', isSelected: false },
      { id: 2, value: 'Model', isSelected: false },
      { id: 3, value: 'Part of the body protected', isSelected: false },
      { id: 4, value: 'Date Assignment', isSelected: false },
    ];
  }

  datatableColumns5(): void {

    this.datatableColsDefs5 = [
      {
        targets: 0,
        visible: false,
        orderable: false,
      },
      {
        targets: 1,
        orderable: false,
        className: 'select-checkbox'
      },
    ];

    this.datatableCols5 = [
      { id: 2, value: 'Description', isSelected: false },
      { id: 3, value: 'Exam Date', isSelected: false },
      { id: 4, value: 'Outcome', isSelected: false },
      { id: 5, value: 'Notes', isSelected: false },
      { id: 6, value: 'Cost', isSelected: false },
      { id: 7, value: 'Attachments', isSelected: false },
    ];
  }

  datatableColumns6(): void {

    this.datatableColsDefs6 = [
      {
        targets: 0,
        visible: false,
        orderable: false,
      },
      {
        targets: 1,
        orderable: false,
        className: 'select-checkbox'
      },
    ];

    this.datatableCols6 = [
      { id: 2, value: 'No.', isSelected: false },
      { id: 3, value: 'Subject', isSelected: false },
      { id: 4, value: 'Text', isSelected: false },
      { id: 5, value: 'Date', isSelected: false },
    ];
  }



  datatableFilterAction(): void {
    // console.log(DataTables.Api);
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {

      dtInstance.draw();

      // dtInstance.columns().every(function () {});


    });
  }

  // generalsFormInit(): void {

  //   this.generalsForm = this.formBuilder.group({
  //     address: [this.emp.employee_address],
  //     phone: [this.emp.employee_phone],
  //     tax_code: [this.emp.employee_tax_code],
  //     dob: [this.emp.emp_dob],
  //     placeofbirth: [this.emp.employee_placeOfbirth],
  //     task: [this.emp.employee_task],
  //     qualifications: [this.emp.employee_qualification],
  //     titleofstudy: [this.emp.employee_timeOfstudy],
  //     assumptiondate: [this.emp.emp_assumption_date],
  //     hourlycost: [this.emp.employee_houly_cost]
  //   });

  // }

  generalsFormInit(): void {
    this.generalsForm = this.formBuilder.group({
      address: [''],
      phone: [''],
      tax_code: [''],
      dob: [''],
      placeofbirth: [''],
      task: [''],
      qualifications: [''],
      titleofstudy: [''],
      assumptiondate: [''],
      hourlycost: [''],
    });
  }

  FormBuildUpdate(): void {

    this.generalsForm.patchValue({
      address: this.emp.employee_address,
      phone: this.emp.employee_phone,
      tax_code: this.emp.employee_tax_code,
      dob: this.emp.emp_dob,
      placeofbirth: this.emp.employee_placeOfbirth,
      task: this.emp.employee_task,
      qualifications: this.emp.employee_qualification,
      titleofstudy: this.emp.employee_timeOfstudy,
      assumptiondate: this.emp.emp_assumption_date,
      hourlycost: this.emp.employee_houly_cost
    });
  }


  fileDesign() {
    $(".filestyle").filestyle({
      'htmlIcon': '<i class="fa fa-inbox mr-5"></i>',
      'btnClass': 'btn-default',
    });
  }


  FormBuild(): void {
    this.createForm = this.formBuilder.group({
      attachment: this.formBuilder.array([this.newAttachment()], [Validators.required]),
      expiry: [''],
      ref_id: [this.cid],
      option: [''],
      emp_id: [this.id],
      type: 'curriculum',
      action: 'certification_update',
    });

    setTimeout(() => this.fileDesign(), 10);
    this.attachment().valueChanges.subscribe(values => {
      setTimeout(() => this.attachment(), 10);
    });


    this.createFormErrorMsg = {
      'attachment': [{ type: 'required', message: 'sss' }],
    }

  }


  FormBuildUpdate1(): void {

    this.createForm.patchValue({
      expiry: this.cexpiry,
      option:this.coption
    });

  }



  attachment(): FormArray {
    return this.createForm.get('attachment') as FormArray;
  };

  newAttachment(): FormGroup {
    return this.formBuilder.group({
      link: ['']
    });
  }

  public selectAttachment(event: any, index) {

    this.createForm.value.attachment[index].link = File;

    if (event.target.files.length > 0) {
      const file = event.target.files[0];

      let reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = () => {
        this.createForm.value.attachment[index].link = { 'name': file.name, 'image': reader.result };
      };
    }

  }


  FormBuild2(): void {

    this.createForm2 = this.formBuilder.group({
      attachment2: this.formBuilder.array([this.newAttachment2()], [Validators.required]),
      expiry: [''],
      ref_id: [this.identityid],
      option: [''],
      emp_id: [this.id],
      type: 'identity',
      action: 'certification_update',
    });

    setTimeout(() => this.fileDesign(), 10);
    this.attachment2().valueChanges.subscribe(values => {
      setTimeout(() => this.attachment2(), 10);
    });


    this.createFormErrorMsg = {
      'attachment2': [{ type: 'required', message: 'sss' }],
    }

  }

  FormBuildUpdate2(): void {

    this.createForm2.patchValue({
      expiry: this.idexpiry,
      option: this.idoption,
      
    });

  }


  attachment2(): FormArray {
    return this.createForm2.get('attachment2') as FormArray;
  };

  newAttachment2(): FormGroup {
    return this.formBuilder.group({
      link: ['']
    });
  }

  public selectAttachment2(event: any, index) {

    this.createForm2.value.attachment2[index].link = File;

    if (event.target.files.length > 0) {
      const file = event.target.files[0];

      let reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = () => {
        this.createForm2.value.attachment2[index].link = { 'name': file.name, 'image': reader.result };
      };
    }

  }



  FormBuild3(): void {

    this.createForm3 = this.formBuilder.group({
      attachment3: this.formBuilder.array([this.newAttachment3()], [Validators.required]),
      expiry: [''],
      ref_id: [this.did],
      option: ['1'],
      emp_id: [this.id],
      type: 'drivers',
      action: 'certification_update',
    });

    setTimeout(() => this.fileDesign(), 10);
    this.attachment3().valueChanges.subscribe(values => {
      setTimeout(() => this.attachment3(), 10);
    });


    this.createFormErrorMsg = {
      'attachment3': [{ type: 'required', message: 'sss' }],
    }

  }


  FormBuildUpdate3(): void {

    this.createForm3.patchValue({
      expiry: this.iddrivers,
      option: this.doption,
    });

  }

  attachment3(): FormArray {
    return this.createForm3.get('attachment3') as FormArray;
  };

  newAttachment3(): FormGroup {
    return this.formBuilder.group({
      link: ['']
    });
  }

  public selectAttachment3(event: any, index) {

    this.createForm3.value.attachment3[index].link = File;

    if (event.target.files.length > 0) {
      const file = event.target.files[0];

      let reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = () => {
        this.createForm3.value.attachment3[index].link = { 'name': file.name, 'image': reader.result };
      };
    }

  }


  FormBuild4(): void {

    this.createForm4 = this.formBuilder.group({
      attachment4: this.formBuilder.array([this.newAttachment4()], [Validators.required]),
      expiry: [''],
      ref_id: [this.conid],
      option: ['1'],
      emp_id: [this.id],
      type: 'contract',
      action: 'certification_update',
    });

    setTimeout(() => this.fileDesign(), 10);
    this.attachment4().valueChanges.subscribe(values => {
      setTimeout(() => this.attachment(), 10);
    });


    this.createFormErrorMsg = {
      'attachment4': [{ type: 'required', message: 'sss' }],
    }

  }

  FormBuildUpdate4(): void {

    this.createForm4.patchValue({
      expiry: this.coexpiry,
      option: this.conoption,
    });

  }

  attachment4(): FormArray {
    return this.createForm.get('attachment') as FormArray;
  };

  newAttachment4(): FormGroup {
    return this.formBuilder.group({
      link4: ['']
    });
  }

  public selectAttachment4(event: any, index) {

    this.createForm4.value.attachment4[index].link4 = File;

    if (event.target.files.length > 0) {
      const file = event.target.files[0];

      let reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = () => {
        this.createForm4.value.attachment4[index].link4 = { 'name': file.name, 'image': reader.result };
      };
    }

  }




  getData() {
    this.route.params.subscribe(params => {
      this.id = params.id;

      this.employeeService.generalList(this.id)
        .subscribe(
          (res) => {

            this.lang = this.employeeService.employeeviewLang(res);
            console.log("==== Emp Lang =====")
            console.log(this.lang)
            this.id = this.id;
            this.isApiLoaded = true;
            this.emp = res.data.emp;
            this.leftside = res.data.leftside;
            this.rightside = res.data.rightside;
            this.allrec_round = res.data.allrec_round;
            this.coexpiry = res.data.contract.expiry;

            // console.log(this.cexpiry);

            this.chart_left = res.data.chart_left;
            this.chart_right = res.data.chart_right;
            this.chart_center = res.data.chart_center;


            this.barChartLabels = res.data.chart_name;
            this.barChartValues = res.data.chart;
            this.barChartMaxValues = res.data.chartmaxLevel;
            this.barChartType = 'horizontalBar';
            this.backgroundColor = "blue";


            this.barChartData = [
              { data: JSON.parse(res.data.chart) },
            ];
            this.chartColors = [
              { backgroundColor: ["#008000", "#ff0000", "#ff0000"] },
            ];

            if (res.data.curriculum != null) {
              this.curriculum = res.data.curriculum.attachment;
              this.identity = res.data.identity.attachment;
              this.cexpiry = res.data.curriculum.expiry;
              this.cid = res.data.curriculum.id;

            }
            else {
              this.curriculum = '';
              this.cid = '';
              this.cexpiry = '';
            }

            


            this.FormBuild();
            this.FormBuild2();
            this.FormBuild3();
            this.FormBuild4();
            // this.generalsFormInit();
            this.FormBuildUpdate();
            this.FormBuildUpdate1();
            this.FormBuildUpdate2();
            this.FormBuildUpdate3();
            this.FormBuildUpdate4();

            // console.log(this.emp.employee_address);

            //load datatable
            this.datatableConfig1();
            this.loadChart()
          }
        );

    });
    this.createFormErrorMsg = {
      'expiry': [{ type: 'required', message: 'This field is required' }],
    };


  }

  tab2Actions(): void {

    this.route.params.subscribe(params => {
      this.id = params.id;

      this.employeeService.generalList(this.id)
        .subscribe(
          (res) => {
            this.lang = this.employeeService.employeeviewLang(res);
            this.training = this.training_temp = res.data.training;



            if (res.data.curriculum != '') {
              this.curriculum = res.data.curriculum.attachment;
              this.identity = res.data.identity.attachment;
              this.cexpiry = res.data.curriculum.expiry;
              this.cid = res.data.curriculum.id;
              this.coption = res.data.curriculum.option;


            if (this.coption == 0)
            {
              this.coption = '';
            }
            else {
              this.coption = this.coption;
            }
              
            }
            // else
            // {
            //   this.curriculum = '';
            //   this.cid = '';
            //   this.cexpiry = '';
            //   }



            if (res.data.identity != null) {
              this.identity = res.data.identity.attachment;
              this.identityid = res.data.identity.id;
              this.idexpiry = res.data.identity.expiry;
              this.idoption = res.data.identity.option;

              if (this.idoption == 0)
              {
                this.idoption = '';
              }
              else {
                this.idoption = this.idoption;
              }

            }
            else {
              this.identity = '';
              this.identityid = '';
              this.idexpiry = '';
              this.idoption = '';
            }

            // console.log(this.idoption);

            if (res.data.drivers != null) {
              this.drivers = res.data.drivers.attachment;
              this.did = res.data.drivers.id;
              this.iddrivers = res.data.drivers.expiry;
              this.doption = res.data.drivers.option;

              if (this.doption == 0)
              {
                this.doption = '';
              }
              else {
                this.doption = this.doption;
              }
            }
            else {
              this.drivers = '';
              this.did = '';
              this.iddrivers = '';
              this.doption = '';
            }


            // console.log(this.doption);

            if (res.data.contract != '') {
              this.contract = res.data.contract.attachment;
              this.conid = res.data.contract.id;
              this.coexpiry = res.data.contract.expiry;
              this.conoption = res.data.contract.option;


            if (this.conoption == 0)
            {
              this.conoption = '';
            }
            else {
              this.conoption = this.conoption;
            }
              
            }
            else {
              this.contract = '';
              this.conid = '';
              this.coexpiry = '';
              this.conoption = '';
            }


            // console.log(this.conoption);

            if (this.curriculum != '') {
              // console.log('test');
              $('#curriculum_val').hide();
              $('#curriculum_edit').show();
              $('#curriculum_edata').html(this.curriculum);

            }
            else {
              $('#curriculum_val').show();
              $('#curriculum_edit').hide();

            }

            if (this.identity != '') {
              $('#identity_papers_val').hide();
              $('#identity_papers_edit').show();
              $('#identity_papers_edata').html(this.identity);
            }
            else {
              $('#identity_papers_val').show();
              $('#identity_papers_edit').hide();
            }


            if (this.drivers != '') {
              // console.log(this.curriculum);
              $('#drivers_license_val').hide();
              $('#drivers_license_edit').show();
              $('#drivers_license_edata').html(this.drivers);
            }
            else {
              $('#drivers_license_val').show();
              $('#drivers_license_edit').hide();
            }

            if (this.contract != '') {
              // console.log(this.curriculum);
              $('#contract_val').hide();
              $('#contract_edit').show();
              $('#contract_edata').html(this.contract);
            }
            else {
              $('#contract_val').show();
              $('#contract_edit').hide();
            }

            this.FormBuild();
            this.FormBuild2();
            this.FormBuild3();
            this.FormBuild4();
            this.FormBuildUpdate1();
            this.FormBuildUpdate2();
            this.FormBuildUpdate3();
            this.FormBuildUpdate4();

          }
        );

    });


  }


  tab3firstActions(): void {

    // setTimeout(()=>this.showContent=true, 250);
    this.route.params.subscribe(params => {
      this.id = params.id;

      this.employeeService.generalList(this.id)
        .subscribe(
          (res) => {

            this.lang = this.employeeService.employeeviewLang(res);

            this.first1 = res.data.first1;

            this.FormBuild();
            this.FormBuildUpdate();

            this.scriptActions();

            this.datatableConfig2();

          }
        );
    });
  }


  tab3secondActions(): void {

    this.route.params.subscribe(params => {
      this.id = params.id;

      this.employeeService.generalList(this.id)
        .subscribe(
          (res) => {

            this.lang = this.employeeService.employeeviewLang(res);


            this.emp = res.data.emp;
            this.leftside = res.data.leftside;
            this.rightside = res.data.rightside;
            this.allrec_round = res.data.allrec_round;
            this.tab2seconddpi = res.data.first_device;

            this.FormBuildUpdate();
            this.FormBuild();
            this.scriptActions();

            this.datatableConfig3();

          }
        );
    });
  }


  tab3thirdActions(): void {

    this.route.params.subscribe(params => {
      this.id = params.id;

      this.employeeService.generalList(this.id)
        .subscribe(
          (res) => {

            this.lang = this.employeeService.employeeviewLang(res);
            this.device = res.data.device;

            this.FormBuildUpdate();
            this.FormBuild();
            this.scriptActions();
            this.datatableConfig4();

          });
    });
  }

  tab4Actions(): void {

    this.route.params.subscribe(params => {
      this.id = params.id;

      this.employeeService.medicalList(this.id)
        .subscribe(
          (res) => {

            this.lang = this.employeeService.employeeviewLang(res);
            this.medicalData = this.medical_temp = res.data.medical_examination_tab;
            this.datatableConfig5();

          });
    });
  }

  tab5Actions(): void {

    this.route.params.subscribe(params => {
      this.id = params.id;

      this.employeeService.notifyList(this.id)
        .subscribe(
          (res) => {

            this.lang = this.employeeService.employeeviewLang(res);
            this.notifi = this.notify_temp = res.data.notifi;

            this.datatableConfig6();

          });
    });
  }

  //sidebar scripts
  scriptActions(): void {

    setTimeout(function () {

      $('.filestyle').each(function () {
        var $this = $(this), options = {
          'input': $this.attr('data-input') !== 'false',
          'htmlIcon': $this.attr('data-icon'),
          'buttonBefore': $this.attr('data-buttonBefore') === 'true',
          'disabled': $this.attr('data-disabled') === 'true',
          'size': $this.attr('data-size'),
          'text': $this.attr('data-text'),
          'btnClass': $this.attr('data-btnClass'),
          'badge': $this.attr('data-badge') === 'true',
          'dragdrop': $this.attr('data-dragdrop') !== 'false',
          'badgeName': $this.attr('data-badgeName'),
          'placeholder': $this.attr('data-placeholder')
        };

        $this.filestyle(options);
      });

    }, 500);

  }



  error(msg: any) {
    this.generalService.notify_msg('error', msg);
  }

  redirect() {
    this.router.navigateByUrl('/test', { skipLocationChange: true })
      .then(() => {
        this.router.navigate([AppFrontRoutes.Servicing_List]);
      });
  }

  success(msg: any) {

    //show success message
    this.generalService.notify_msg('success', msg);

    //redirect the current page
    // this.redirect();

    this.router.navigateByUrl('/test', { skipLocationChange: true })
      .then(() => {
        this.router.navigate([AppFrontRoutes.EMPLOYEE_VIEW + '/' + this.id]);
      });
    // setTimeout(() => {
    //   window.location.reload();
    // }, 3000);


  }


  mulitSelect() {
    this.dropdownList = [
      { item_id: this.lang.vehicle, item_text: this.lang.vehicle },
      { item_id: this.lang.plant, item_text: this.lang.plant },
      { item_id: this.lang.machine, item_text: this.lang.machine },
      { item_id: this.lang.fireDispenser, item_text: this.lang.fireDispenser },
      { item_id: this.lang.firstServiceDevice, item_text: this.lang.firstServiceDevice },
      { item_id: this.lang.individualProtectionDevice, item_text: this.lang.individualProtectionDevice },
      { item_id: this.lang.safetyEquipment, item_text: this.lang.safetyEquipment }
    ];


    let that = this;

    let loca = this.lang.locations;
    Object.keys(loca).forEach(function (key) {
      // console.log(loca[key]);   
      that.dropdownList1.push({ item_id: loca[key], item_text: loca[key] },)
    });


    let loca1 = this.lang.responsibles;
    Object.keys(loca1).forEach(function (key) {
      // console.log(loca1[key]);   
      that.dropdownList2.push({ item_id: loca1[key], item_text: loca1[key] },)
    });


    this.dropdownList3 = [
      { item_id: this.lang.active, item_text: this.lang.active },
      { item_id: this.lang.decommissioned, item_text: this.lang.decommissioned },
    ];

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableCheckAll: true,
      itemsShowLimit: 3,
      allowSearchFilter: true
    };

    this.dropdownSettings1 = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: false
    };

    this.dropdownSettings2 = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: false
    };

    this.dropdownSettings3 = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: false
    };


  }


  export1_select_deselect_all(event): void {

    let selected = false;

    if (event.target.checked)
      selected = true;

    for (var i = 0; i < this.datatableCols1.length; i++) {
      this.datatableCols1[i].isSelected = selected;
    }
    this.datatable_export1_choose_column();

  }

  export1_select_deselect(event): void {

    let selected = false;
    let id = event.target.value;

    if (event.target.checked)
      selected = true;

    for (var i = 0; i < this.datatableCols1.length; i++) {
      if (this.datatableCols1[i].id == id)
        this.datatableCols1[i].isSelected = selected;
    }

    this.datatable_export1_choose_column();

  }

  datatable_export1_choose_column(): void {

    var table1_name = '#table1';
    var table1 = new $.fn.dataTable.Api(table1_name);

    for (var i = 0; i < this.datatableCols1.length; i++) {
      if (this.datatableCols1[i].isSelected)
        table1.column(parseInt(this.datatableCols1[i].id)).select();
      else
        table1.column(parseInt(this.datatableCols1[i].id)).deselect();
    }

  }



  export2_select_deselect_all(event): void {

    let selected = false;

    if (event.target.checked)
      selected = true;

    for (var i = 0; i < this.datatableCols2.length; i++) {
      this.datatableCols2[i].isSelected = selected;
    }
    this.datatable_export2_choose_column();

  }

  export2_select_deselect(event): void {

    let selected = false;
    let id = event.target.value;

    if (event.target.checked)
      selected = true;

    for (var i = 0; i < this.datatableCols2.length; i++) {
      if (this.datatableCols2[i].id == id)
        this.datatableCols2[i].isSelected = selected;
    }

    this.datatable_export2_choose_column();

  }

  datatable_export2_choose_column(): void {

    var table1_name = '#table2';
    var table1 = new $.fn.dataTable.Api(table1_name);

    for (var i = 0; i < this.datatableCols2.length; i++) {
      if (this.datatableCols2[i].isSelected)
        table1.column(parseInt(this.datatableCols2[i].id)).select();
      else
        table1.column(parseInt(this.datatableCols2[i].id)).deselect();
    }

  }


  export3_select_deselect_all(event): void {

    let selected = false;

    if (event.target.checked)
      selected = true;

    for (var i = 0; i < this.datatableCols3.length; i++) {
      this.datatableCols3[i].isSelected = selected;
    }
    this.datatable_export3_choose_column();

  }

  export3_select_deselect(event): void {

    let selected = false;
    let id = event.target.value;

    if (event.target.checked)
      selected = true;

    for (var i = 0; i < this.datatableCols3.length; i++) {
      if (this.datatableCols3[i].id == id)
        this.datatableCols3[i].isSelected = selected;
    }

    this.datatable_export3_choose_column();

  }

  datatable_export3_choose_column(): void {

    var table1_name = '#table3';
    var table1 = new $.fn.dataTable.Api(table1_name);

    for (var i = 0; i < this.datatableCols3.length; i++) {
      if (this.datatableCols3[i].isSelected)
        table1.column(parseInt(this.datatableCols3[i].id)).select();
      else
        table1.column(parseInt(this.datatableCols3[i].id)).deselect();
    }

  }

  // datatable_export3_choose_column(): void {

  //   let vcnt = $('th:first-child input').val();
  //   for (let j = 1; j <= vcnt; j++) {

  //     var table1_name = '.otable' + j;
  //     var table1 = new $.fn.dataTable.Api(table1_name);

  //     for (var i = 0; i < this.datatableCols3.length; i++) {
  //       if (this.datatableCols3[i].isSelected)
  //         table1.column(parseInt(this.datatableCols3[i].id)).select();
  //       else
  //         table1.column(parseInt(this.datatableCols3[i].id)).deselect();
  //     }
  //   }

  // }


  export4_select_deselect_all(event): void {

    let selected = false;

    if (event.target.checked)
      selected = true;

    for (var i = 0; i < this.datatableCols4.length; i++) {
      this.datatableCols4[i].isSelected = selected;
    }
    this.datatable_export4_choose_column();

  }

  export4_select_deselect(event): void {

    let selected = false;
    let id = event.target.value;

    if (event.target.checked)
      selected = true;

    for (var i = 0; i < this.datatableCols4.length; i++) {
      if (this.datatableCols4[i].id == id)
        this.datatableCols4[i].isSelected = selected;
    }

    this.datatable_export4_choose_column();

  }

  datatable_export4_choose_column(): void {

    var table1_name = '#table4';
    var table1 = new $.fn.dataTable.Api(table1_name);

    for (var i = 0; i < this.datatableCols4.length; i++) {
      if (this.datatableCols4[i].isSelected)
        table1.column(parseInt(this.datatableCols4[i].id)).select();
      else
        table1.column(parseInt(this.datatableCols4[i].id)).deselect();
    }

  }

  export5_select_deselect_all(event): void {

    let selected = false;

    if (event.target.checked)
      selected = true;

    for (var i = 0; i < this.datatableCols5.length; i++) {
      this.datatableCols5[i].isSelected = selected;
    }
    this.datatable_export5_choose_column();

  }

  export5_select_deselect(event): void {

    let selected = false;
    let id = event.target.value;

    if (event.target.checked)
      selected = true;

    for (var i = 0; i < this.datatableCols5.length; i++) {
      if (this.datatableCols5[i].id == id)
        this.datatableCols5[i].isSelected = selected;
    }

    this.datatable_export5_choose_column();

  }

  datatable_export5_choose_column(): void {

    var table1_name = '#table5';
    var table1 = new $.fn.dataTable.Api(table1_name);

    for (var i = 0; i < this.datatableCols5.length; i++) {
      if (this.datatableCols5[i].isSelected)
        table1.column(parseInt(this.datatableCols5[i].id)).select();
      else
        table1.column(parseInt(this.datatableCols5[i].id)).deselect();
    }

  }



  export6_select_deselect_all(event): void {

    let selected = false;

    if (event.target.checked)
      selected = true;

    for (var i = 0; i < this.datatableCols6.length; i++) {
      this.datatableCols6[i].isSelected = selected;
    }
    this.datatable_export6_choose_column();

  }

  export6_select_deselect(event): void {

    let selected = false;
    let id = event.target.value;

    if (event.target.checked)
      selected = true;

    for (var i = 0; i < this.datatableCols6.length; i++) {
      if (this.datatableCols6[i].id == id)
        this.datatableCols6[i].isSelected = selected;
    }

    this.datatable_export6_choose_column();

  }

  datatable_export6_choose_column(): void {

    var table1_name = '#table6';
    var table1 = new $.fn.dataTable.Api(table1_name);

    for (var i = 0; i < this.datatableCols6.length; i++) {
      if (this.datatableCols6[i].isSelected)
        table1.column(parseInt(this.datatableCols6[i].id)).select();
      else
        table1.column(parseInt(this.datatableCols6[i].id)).deselect();
    }

  }



  setPageView(view) {
    this.pageView = view;
  }




  delete(ID) {

    this.confirmationDialogService.confirm('Delete Confirmation', 'Are you sure to delete?')
      .subscribe(
        (confirmed) => {

          if (!confirmed)
            return;

          this.servicingService.delete(ID)
            .subscribe(
              (res) => {
                if (res.status)
                  this.success(res.msg);
                else
                  this.error(res.msg);
              });

        });
  }

  deletesdpi(DID, empID, SID) {

    // console.log(empID);

    this.confirmationDialogService.confirm('Delete Confirmation', 'Are you sure want to remove this?')
      .subscribe(
        (confirmed) => {



          if (!confirmed)
            return;

          this.employeeService.deletetdpi(DID, empID, SID)
            .subscribe(
              (res) => {

                // return false;

                if (res.status)
                  this.success(res.msg);
                else
                  this.error(res.msg);
              });

        });
  }


  delete_extraordinary(ID) {

    this.confirmationDialogService.confirm('Servicing Delete Confirmation', 'Do you want to delete this?')
      .subscribe(
        (confirmed) => {

          if (!confirmed)
            return;

          this.servicingService.delete_extraordinary(ID)
            .subscribe(
              (res) => {
                if (res.status)
                  this.success(res.msg);
                else
                  this.error(res.msg);
              });

        });
  }

  delete_ordinary(ID) {

    this.confirmationDialogService.confirm('Servicing Delete Confirmation', 'Do you want to delete this?')
      .subscribe(
        (confirmed) => {

          if (!confirmed)
            return;

          this.servicingService.delete_ordinary(ID)
            .subscribe(
              (res) => {
                if (res.status)
                  this.success(res.msg);
                else
                  this.error(res.msg);
              });

        });
  }


  delete_sdocuments(ID) {

    this.confirmationDialogService.confirm('Servicing Documents Delete Confirmation', 'Do you want to delete this?')
      .subscribe(
        (confirmed) => {

          if (!confirmed)
            return;

          this.servicingService.delete_sdocuments(ID)
            .subscribe(
              (res) => {
                if (res.status)
                  this.success(res.msg);
                else
                  this.error(res.msg);
              });

        });
  }


  turnoff(sID, pid, rid) {

    this.confirmationDialogService.confirm('Servicing Delete Confirmation', 'Are you sure to deactivate?')
      .subscribe(
        (confirmed) => {

          if (!confirmed)
            return;

          this.servicingService.turnoff(sID, pid, rid)
            .subscribe(
              (res) => {
                if (res.status)
                  this.success(res.msg);
                else
                  this.error(res.msg);
              });
          $("#sactivate_plan").modal("hide");
        });
  }

  activate_plan(pid, sId) {

    $("#plan_id_forcd").val(pid);
    $("#pservice_id").val(sId);
    $("#sactivate_plan").modal("show");
  }

  multiDelete() {

    var table1 = new $.fn.dataTable.Api('#table1');
    let selectedRows = table1.rows({ selected: true }).ids().toArray();

    // console.log('testtest'); return false;

    this.confirmationDialogService.confirm('User Confirmation', 'Are you sure to delete the selected rows?')
      .subscribe(
        (confirmed) => {

          if (!confirmed)
            return;

          this.servicingService.multiDelete(selectedRows)
            .subscribe(
              (res) => {
                if (res.status)
                  this.success(res.msg);
                else
                  this.error(res.msg);
              });
        });
  }



  multiDelete1() {

    var table1 = new $.fn.dataTable.Api('#table2');
    let selectedRows = table1.rows({ selected: true }).ids().toArray();

    // console.log(selectedRows); return false;

    this.confirmationDialogService.confirm('User Confirmation', 'Are you sure to delete the selected rows?')
      .subscribe(
        (confirmed) => {
          if (!confirmed)
            return;

          this.servicingService.delete_mextraordinary(selectedRows)
            .subscribe(
              (res) => {
                if (res.status)
                  this.success(res.msg);
                else
                  this.error(res.msg);
              });
        });
  }


  doc_multiDelete() {

    var table4 = new $.fn.dataTable.Api('#table4');
    let selectedRows = table4.rows({ selected: true }).ids().toArray();

    // console.log(selectedRows); return false;

    this.confirmationDialogService.confirm('User Confirmation', 'Are you sure to delete the selected rows?')
      .subscribe(
        (confirmed) => {
          if (!confirmed)
            return;

          this.servicingService.delete_msdocuments(selectedRows)
            .subscribe(
              (res) => {
                if (res.status)
                  this.success(res.msg);
                else
                  this.error(res.msg);
              });
        });
  }


  deleteMultiOrdinary() {
    // console.log('sss1');
    var vcnt = $('th:first-child input').val();
    var oid = $('#dmulval').val();

    if (oid != "") {
      // console.log(oid);
      this.confirmationDialogService.confirm('User Confirmation', 'Are you sure to delete the selected rows?')
        .subscribe(
          (confirmed) => {

            if (!confirmed)
              return;

            this.servicingService.deleteMultiOrdinary(oid)
              .subscribe(
                (res) => {
                  if (res.status)
                    this.success(res.msg);
                  else
                    this.error(res.msg);
                });
          });


    }
    else {
      for (let i = 1; i <= vcnt; i++) {
        // console.log(i);
        if ($('.chk' + i).is(":checked")) {
          var table3 = new $.fn.dataTable.Api('.otable' + i);
          // var table3 = new $.fn.dataTable.Api('.otable3');
          let selectedRows = table3.rows({ selected: true }).ids().toArray();

          this.confirmationDialogService.confirm('User Confirmation', 'Are you sure to delete the selected rows?')
            .subscribe(
              (confirmed) => {

                if (!confirmed)
                  return;

                this.servicingService.deleteMultiOrdinary(selectedRows)
                  .subscribe(
                    (res) => {
                      if (res.status)
                        this.success(res.msg);
                      else
                        this.error(res.msg);
                    });
              });
        }
      }
    }

  }


  multiDuplicate() {

    var table2 = new $.fn.dataTable.Api('#table2');
    let selectedRows = table2.rows({ selected: true }).ids().toArray();


    this.servicingService.multiExtraDuplicate(selectedRows)
      .subscribe(
        (res) => {
          if (res.status)
            this.success(res.msg);
          else
            this.error(res.msg);
        });

  }

  multiOrdDuplicate() {

    let vcnt = $('th:first-child input').val();
    for (let i = 1; i <= vcnt; i++) {
      if ($('.chk' + i).is(":checked")) {
        var table3 = new $.fn.dataTable.Api('.otable' + i);
        let selectedRows = table3.rows({ selected: true }).ids().toArray();

        this.servicingService.multiOrdDuplicate(selectedRows)
          .subscribe(
            (res) => {
              if (res.status)
                this.success(res.msg);
              else
                this.error(res.msg);
            });
      }
    }

  }

  doc_multiDuplicate() {

    var table3 = new $.fn.dataTable.Api('#table4');
    let selectedRows = table3.rows({ selected: true }).ids().toArray();


    this.servicingService.doc_multiDuplicate(selectedRows)
      .subscribe(
        (res) => {
          if (res.status)
            this.success(res.msg);
          else
            this.error(res.msg);
        });

  }

  duplicate(ID) {

    this.confirmationDialogService.confirm('Duplicate Confirmation', 'Are you sure you duplicate this line?')
      .subscribe(
        (confirmed) => {

          if (!confirmed)
            return;

          this.servicingService.duplicate(ID)
            .subscribe(
              (res) => {
                if (res.status)
                  this.success(res.msg);
                else
                  this.error(res.msg);
              });

        });


  }




  onPhotoPickerChange(ev) {
    let file = ev.target.files[0];
    file = ev.target.files[0];

    // console.log(file.name);
    let file_name = file.name;
    if (!(/\.(csv)$/i).test(file_name)) {
      alert('Please upload valid excel file_name .csv only.');
      $('#file').val('');
    }
    else {
      let fs = new FileReader();
      fs.onload = (res: any) => {
        this.getPhotoBase64 = res.target.result;
        $('#profile_input').val('');
      };
      fs.readAsDataURL(file);
    }
  }

  onclick() {
    let profileImage = this.getPhotoBase64 ? this.getPhotoBase64.split(',').pop() : this.getPhotoBase64;

    if (profileImage != undefined && $('#file').val() != '') {
      this.servicingService.updateImport(profileImage)
        .subscribe(
          (res) => {
            if (res.status) {
              // this.success(res.msg);
              // $("#datatableExport4").modal("hide");
              this.router.navigateByUrl('/test', { skipLocationChange: true })
                .then(() => {
                  this.router.navigate([AppFrontRoutes.Servicing_List]);
                });
              setTimeout(() => {
                window.location.reload();
              }, 3000);

            }
            else {
              // this.error(res.msg);
              // $("#datatableExport4").modal("hide");
              this.router.navigateByUrl('/test', { skipLocationChange: true })
                .then(() => {
                  this.router.navigate([AppFrontRoutes.Servicing_List]);
                });
              setTimeout(() => {
                window.location.reload();
              }, 3000);
            }
          });
    }
  }


  onSubmit(data) {

    // console.log(data.date); return false;

    var plan_id_forcd = $("#plan_id_forcd").val();
    var pservice_id = $("#pservice_id").val();

    if (data.date != "") {
      this.servicingService.active_status(data.date, plan_id_forcd, pservice_id)
        .subscribe(
          (res) => {
            if (res.status) {
              this.success(res.msg);
              $("#sactivate_plan").modal("hide");
            }
            else {
              this.error(res.msg);
              $("#sactivate_plan").modal("hide");

            }
          });
    }
    else {
      alert('Please Enter Start Date!!!');
    }

  }

  // add_extraordinary(SID) {
  //   this.extraordinayModal = this.modalService.show(ServicingExtraOrdinaryComponent, { class: 'modal-lgs', initialState: { 'SID': SID, 'langs': this.exodlang } });
  // }

  // edit_extraordinary(ID) {
  //   this.extraordinayModal = this.modalService.show(ServicingExtraOrdinaryComponent, { class: 'modal-lgs', initialState: { 'ID': ID, 'langs': this.exodlang } });
  // }


  // add_ordinary(SID, PID) {
  //   // console.log(PID);
  //   this.ordinayModal = this.modalService.show(ServicingOrdinaryComponent, { class: 'modal-lgs', initialState: { 'SID': SID, 'PID': PID, 'langs': this.odlang } });
  // }

  // edit_ordinary(ID, SID, PID) {
  //   this.ordinayModal = this.modalService.show(ServicingOrdinaryComponent, { class: 'modal-lgs', initialState: { 'ID': ID, 'SID': SID, 'PID': PID, 'langs': this.odlang, 'action': "edit" } });
  // }


  // duplicate_ordinary(ID, SID, PID) {
  //   this.ordinayModal = this.modalService.show(ServicingOrdinaryComponent, { class: 'modal-lgs', initialState: { 'ID': ID, 'SID': SID, 'PID': PID, 'langs': this.odlang, 'action': "duplicate" } });
  // }


  // add_sdocuments(SID) {
  //   console.log(SID);
  //   this.ordinayModal = this.modalService.show(ServicingDocumentsComponent, { class: 'modal-lgs', initialState: { 'SID': SID, 'langs': this.doclang } });
  // }


  // edit_sdocuments(ID, SID) {
  //   this.ordinayModal = this.modalService.show(ServicingDocumentsComponent, { class: 'modal-lgs', initialState: { 'ID': ID, 'SID': SID, 'langs': this.doclang, 'action': 'edit' } });
  // }



  certification_save(type) {
    // this.createFormSubmitted = true;

    // console.log(this.createForm.value['expiry']); return false;


    if ((this.createForm.value['attachment'][0]['link'] == '') && this.curriculum == '') {

      $('#cerr').html('This field is required');

      if (this.createForm.value['option'] == 1) {
        if (this.createForm.value['expiry'] == '') {
          $('#ceerr').html('This field is required');
        }
        else {
          $('#ceerr').html('');
          return false;
        }
      }
      else {
        $('#ceerr').html('');
        return false;
      }

    }
    else {
      // console.log('sucess1');

      $('#cerr').html('');


      if (this.createForm.value['option'] == 1) {
        if (this.createForm.value['expiry'] == '') {
          $('#ceerr').html('This field is required');
        }
        else {
          $('#ceerr').html('');

          this.employeeService.certification_save(this.createForm.value).subscribe(
            res => {

              $('#curriculum_val').hide();

              $('#curriculum_edit').show();
              $('#curriculum_edata').html(res.attachment);
              $('#ceerr').html('');

            });


          return false;
        }
      }
      else {
        $('#ceerr').html('');

        this.employeeService.certification_save(this.createForm.value).subscribe(
          res => {

            $('#curriculum_val').hide();

            $('#curriculum_edit').show();
            $('#curriculum_edata').html(res.attachment);
            $('#ceerr').html('');

          });


        return false;
      }



    }
  }


  certification_save2(type) {
    // this.createFormSubmitted = true;


    if ((this.createForm2.value['attachment2'][0]['link'] == '') && this.identity == '') {
      $('#iderr').html('This field is required');

      if (this.createForm2.value['option'] == 1) {
        // $('#ideerr').html('This field is required');
        if (this.createForm2.value['expiry'] == '') {
          $('#ideerr').html('This field is required');
        }
        else {
          $('#ideerr').html('');
          return false;
        }
      }
      else {
        $('#ideerr').html('');
        return false;
      }

    }
    else {
      $('#iderr').html('');
      // console.log(this.createForm2.value['expiry']); return false;

      if (this.createForm2.value['option'] == 1) {
        if (this.createForm2.value['expiry'] == '') {
          $('#ideerr').html('This field is required');
        }
        else {
          $('#ideerr').html('');

          this.employeeService.certification_save(this.createForm2.value).subscribe(
            res => {

              $('#identity_papers_val').hide();
              $('#identity_papers_edit').show();
              $('#identity_papers_edata').html(res.attachment);
              $('#ideerr').html('');

            });
        }
      }
      else {
        $('#ideerr').html('');

        this.employeeService.certification_save(this.createForm2.value).subscribe(
          res => {

            $('#identity_papers_val').hide();

            $('#identity_papers_edit').show();
            $('#identity_papers_edata').html(res.attachment);
            $('#ideerr').html('');

          });
      }
    }
  }



  certification_save3(type) {
    // this.createFormSubmitted = true;


    if ((this.createForm3.value['attachment3'][0]['link'] == '') && this.drivers == '') {
      $('#dlerr').html('This field is required');

      if (this.createForm3.value['option'] == 1) {
        // $('#ideerr').html('This field is required');
        if (this.createForm3.value['expiry'] == '') {
          $('#dleerr').html('This field is required');
        }
        else {
          $('#dleerr').html('');
          return false;
        }
      }
      else {
        $('#dleerr').html('');
        return false;
      }

    }
    else {
      $('#dlerr').html('');
      // console.log(this.createForm2.value['expiry']); return false;

      if (this.createForm3.value['option'] == 1) {
        if (this.createForm3.value['expiry'] == '') {
          $('#dleerr').html('This field is required');
        }
        else {
          $('#dleerr').html('');

          this.employeeService.certification_save(this.createForm3.value).subscribe(
            res => {

              $('#drivers_license_val').hide();
              $('#drivers_license_edit').show();
              $('#drivers_license_edata').html(res.attachment);
              $('#dleerr').html('');

            });
        }
      }
      else {
        $('#dleerr').html('');

        this.employeeService.certification_save(this.createForm3.value).subscribe(
          res => {

            $('#drivers_license_val').hide();
            $('#drivers_license_edit').show();
            $('#drivers_license_edata').html(res.attachment);
            $('#dleerr').html('');

          });
      }
    }
  }


  certification_save4(type) {

    // console.log(this.createForm4); return false;

    if ((this.createForm4.value['attachment4'][0]['link4'] == '') && this.contract == '') {
      $('#con_err').html('This field is required');

      if (this.createForm4.value['option'] == 1) {
        // $('#con_eerr').html('This field is required');
        if (this.createForm4.value['expiry'] == '') {
          $('#con_eerr').html('This field is required');
        }
        else {
          $('#con_eerr').html('');
          return false;
        }

      }
      else {
        $('#con_eerr').html('');
        return false;
      }
    }
    else {
      $('#con_err').html('');

      // console.log(this.createForm4.value['option']);
      // console.log(this.createForm4.value['expiry']); return false;

      if (this.createForm4.value['option'] == 1) {
        // $('#con_eerr').html('This field is required');

        // console.log(this.createForm4.value['expiry']); return false;


        if (this.createForm4.value['expiry'] == '') {
      
          $('#con_eerr').html('This field is required');
          return false; return false;
        }
        else {
          // console.log(2); return false;
          $('#con_eerr').html('');
          this.employeeService.certification_save(this.createForm4.value).subscribe(
            res => {
              $('#contract_val').hide();
              $('#contract_edit').show();
              $('#contract_edata').html(res.attachment);
              $('#con_eerr').html('');

            });
          // return false;
        }
      }
      else {
        $('#con_eerr').html('');

        this.employeeService.certification_save(this.createForm4.value).subscribe(
          res => {
            $('#contract_val').hide();
            $('#contract_edit').show();
            $('#contract_edata').html(res.attachment);
            $('#con_eerr').html('');

          });
        return false;
      }
    }
  }

  certification_del(ID, EID) {
    this.confirmationDialogService.confirm('Delete Confirmation', 'Are you sure to delete?')
      .subscribe(
        (confirmed) => {

          if (!confirmed)
            return;

          this.employeeService.certification_delete(ID, EID)
            .subscribe(
              (res) => {
                $('#curriculum_val').show();
                $('#curriculum_edit').hide();
                this.createForm.reset();


                // if (res.status)
                //   this.success(res.msg);
                // else
                //   this.error(res.msg);
              });

        });
  }


  certification_del2(ID, EID) {
    this.confirmationDialogService.confirm('Delete Confirmation', 'Are you sure to delete?')
      .subscribe(
        (confirmed) => {

          if (!confirmed)
            return;

          this.employeeService.certification_delete(ID, EID)
            .subscribe(
              (res) => {
                $('#identity_papers_val').show();
                $('#identity_papers_edit').hide();
                this.createForm2.reset();


                // if (res.status)
                //   this.success(res.msg);
                // else
                //   this.error(res.msg);
              });

        });
  }


  certification_del3(ID, EID) {
    this.confirmationDialogService.confirm('Delete Confirmation', 'Are you sure to delete?')
      .subscribe(
        (confirmed) => {

          if (!confirmed)
            return;

          this.employeeService.certification_delete(ID, EID)
            .subscribe(
              (res) => {
                $('#drivers_license_val').show();
                $('#drivers_license_edit').hide();
                this.createForm3.reset();


                // if (res.status)
                //   this.success(res.msg);
                // else
                //   this.error(res.msg);
              });

        });
  }


  certification_del4(ID, EID) {
    this.confirmationDialogService.confirm('Delete Confirmation', 'Are you sure to delete?')
      .subscribe(
        (confirmed) => {

          if (!confirmed)
            return;

          this.employeeService.certification_delete(ID, EID)
            .subscribe(
              (res) => {
                $('#contract_val').show();
                $('#contract_edit').hide();
                this.createForm4.reset();


                // if (res.status)
                //   this.success(res.msg);
                // else
                //   this.error(res.msg);
              });

        });
  }

  fileshow() {
    $('#curriculum_val').show();
    $('#curriculum_edit').hide();
    $('.filestyle').val(null);
  }

  fileshow4() {
    $('#contract_val').show();
    $('#contract_edit').hide();
    $('.filestyle').val(null);
  }

  viewEmployee() {

    this.viewEmployeeModal = this.modalService.show(EmployeeViewemployeeComponent, { class: 'modal-lgs', initialState: { 'langs': this.lang } });

  }

  addDeliveryreport() {
    this.addDeliveryreportModel = this.modalService.show(CreateDeliveryReportComponent, { class: 'modal-lgs', initialState: { 'ID': '', 'langs': this.lang, 'emp_id': this.emp.employeeId } });

  }

  sendMail(desc: any, ID: any) {
    this.sendMailModel = this.modalService.show(SendMailDpiComponent, { class: 'modal-lgs', initialState: { 'desc': desc, 'ID': ID, 'langs': this.lang } });

  }


  addDpi() {
    this.addProtectiveModel = this.modalService.show(CreateAddProtectiveComponent, { class: 'modal-lgs', initialState: { 'ID': '', 'langs': this.lang, 'emp_id': this.emp.employeeId } });

  }

  editDpi(ID: any) {
    this.addProtectiveModel = this.modalService.show(CreateAddProtectiveComponent, { class: 'modal-lgs', initialState: { 'ID': ID, 'langs': this.lang, 'emp_id': this.emp.employeeId } });

  }

  addDpithird(ID: any) {
    this.addProtectiveModel2 = this.modalService.show(CreateAddThirdProtectiveComponent, { class: 'modal-lgs', initialState: { 'ID': ID, 'langs': this.lang, 'emp_id': this.emp.employeeId } });

  }


  editDpithird(ID: any) {
    this.addProtectiveModel2 = this.modalService.show(CreateAddThirdProtectiveComponent, { class: 'modal-lgs', initialState: { 'ID': ID, 'langs': this.lang, 'emp_id': this.emp.employeeId } });

  }


}
